/*
  Modal Link Controller

  Opens a modal with the content of the link element the controller is attached to. Note that this controller does nothing unless the
  root element responds to 'href'.
*/

export default class extends Controller {

  connect() {
    this.requestModalContent = this.requestModalContent.bind(this)
    this.openModalWithContent = this.openModalWithContent.bind(this)
    this.requestURL && this.element.addEventListener('click', this.requestModalContent);
  }

  requestModalContent(event) {
    event.preventDefault();
    App.Helpers.ajaxRequest({ url: this.requestURL, successHandler: this.openModalWithContent });
  }

  openModalWithContent(content) {
    App.Modal.open({ content, overSlideOut: this.overSlideOut });
    App.addHandlers(App.Modal.topModal());
  }

  //
  // GETTERS AND SETTERS
  //

  get requestURL() {
    return this.element.href;
  }

  get overSlideOut() {
    return App.Helpers.isTruthy(this.data.get("over-slide-out"))
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/modals/modal-link-controller.js